/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DownloadObservabilityPluginSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

/**
 * Target platform.
 */
export const Platform = {
  Claude: "claude",
  Cursor: "cursor",
  Codex: "codex",
  Opencode: "opencode",
  Copilot: "copilot",
  Openclaw: "openclaw",
  Pi: "pi",
} as const;
/**
 * Target platform.
 */
export type Platform = ClosedEnum<typeof Platform>;

export type DownloadObservabilityPluginRequest = {
  /**
   * Target platform.
   */
  platform: Platform;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

export type DownloadObservabilityPluginResponse = {
  headers: { [k: string]: Array<string> };
  result: ReadableStream<Uint8Array>;
};

/** @internal */
export type DownloadObservabilityPluginSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DownloadObservabilityPluginSecurity$outboundSchema: z.ZodMiniType<
  DownloadObservabilityPluginSecurity$Outbound,
  DownloadObservabilityPluginSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function downloadObservabilityPluginSecurityToJSON(
  downloadObservabilityPluginSecurity: DownloadObservabilityPluginSecurity,
): string {
  return JSON.stringify(
    DownloadObservabilityPluginSecurity$outboundSchema.parse(
      downloadObservabilityPluginSecurity,
    ),
  );
}

/** @internal */
export const Platform$outboundSchema: z.ZodMiniEnum<typeof Platform> = z.enum(
  Platform,
);

/** @internal */
export type DownloadObservabilityPluginRequest$Outbound = {
  platform: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DownloadObservabilityPluginRequest$outboundSchema: z.ZodMiniType<
  DownloadObservabilityPluginRequest$Outbound,
  DownloadObservabilityPluginRequest
> = z.pipe(
  z.object({
    platform: Platform$outboundSchema,
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function downloadObservabilityPluginRequestToJSON(
  downloadObservabilityPluginRequest: DownloadObservabilityPluginRequest,
): string {
  return JSON.stringify(
    DownloadObservabilityPluginRequest$outboundSchema.parse(
      downloadObservabilityPluginRequest,
    ),
  );
}

/** @internal */
export const DownloadObservabilityPluginResponse$inboundSchema: z.ZodMiniType<
  DownloadObservabilityPluginResponse,
  unknown
> = z.pipe(
  z.object({
    Headers: z._default(z.record(z.string(), z.array(z.string())), {}),
    Result: z.custom<ReadableStream<Uint8Array>>(x =>
      x instanceof ReadableStream
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "Headers": "headers",
      "Result": "result",
    });
  }),
);

export function downloadObservabilityPluginResponseFromJSON(
  jsonString: string,
): SafeParseResult<DownloadObservabilityPluginResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      DownloadObservabilityPluginResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DownloadObservabilityPluginResponse' from JSON`,
  );
}
